import { PlaceOrderQueryModel } from "@affinity/Store/PrePopulation";
import { customDispatch } from "@affinity/Store/ServiceBase";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

type HandlerType = Handler<PlaceOrderQueryModel>;

const UpdateState: HandlerType = props => {
    (props.dispatch as customDispatch)({
        type: "Affinity/QueryString/PlaceOrder/Set",
        value: props.parameter,
    });
}

const chain = [
    UpdateState,
];

export const QueryStringSetPlaceOrder = createHandlerChainRunner(chain, "QueryStringSetPlaceOrder");
export default QueryStringSetPlaceOrder;